export default "__VITE_ASSET__a4ahX4_G__"